export default __webpack_public_path__ + "static/media/title-bg-smm.d331d2b5.svg";